import { Injectable } from '@angular/core';
import { ApiService } from '../../../app/services/api.service';
import { CommonFunctionService } from 'src/app/services/common-function.service';
import { IProduct } from '../interfaces/product';

@Injectable()
export class ProductApiService {
  constructor(
    private Api: ApiService,
    protected commonFunctionService: CommonFunctionService
  ) {}

  public list(role: string, productId: number) {
    return new Promise((resolve, reject) => {
      const endpoint = `${role}/listings/${productId}/products`;
      const url = this.commonFunctionService.findApiUrl(role);

      this.Api.get(endpoint, url).then(
        (result: IProduct[]) => resolve(result),
        (error) => reject(error)
      );
    });
  }

  public save(
    role: string,
    productId: number,
    product: IProduct,
    listingId: number
  ): Promise<number> {
    let endpoint = `${role}/listings/${listingId}/products`;
    const url = this.commonFunctionService.findApiUrl(role);

    if (productId) {
      endpoint += `/${productId}`;
      return this.Api.put(endpoint, product, url);
    }

    return this.Api.post(endpoint, product, url);
  }
  public delete(role: string, productId: number, listingId: number) {
    return new Promise((resolve, reject) => {
      const endpoint = `${role}/listings/${listingId}/products/${productId}`;
      const url = this.commonFunctionService.findApiUrl(role);

      this.Api.delete(endpoint, url).then(
        (result: IProduct[]) => resolve(result),
        (error) => reject(error)
      );
    });
  }
}
